<template>
  <div class='pivotContainer' v-if="dataProvider" stlye='background:white'>
    <PivotTableModal :cur-widget="dataKey" />
    <b-button 
      variant="primary" 
      @click="editTable">Edit</b-button>
    <PivotAll
      class="pvtAxisContainer"
      :dataName="dataName"
      :dataProvider="dataProvider"
      :options="dataOptions"
      @changeOptions="changedOptions" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
// components
import PivotTableModal from '@/components/Modals/PivotTable'
import PivotAll from '@/components/PivotGrid/PivotAll'
// services
import db from '@/services/db'
// helpers
import eventBus from '@/helpers/event-bus'


export default {
  props: [ 'dataKey' ],
  components: {
    PivotTableModal,
    PivotAll
  },
  data () {
    return {
      dataProvider: null,
      dataName: null
    }
  },
  computed: {
    ...mapState([
      'pivotGridOptions'
    ])
  },
  watch: {
    pivotGridOptions(val) {
      if (!this.dataProvider) {
        this.updateData();
      }
    }
  },
  methods: {
    editTable () {
      eventBus.$emit('showEditPivotTableModal')
    },
    changedOptions(options) {
      const pivotItem = {
        [this.dataKey]: {
          ...this.pivotGridOptions[this.dataKey],
          options: JSON.stringify(options)
        }
      };
      this.$store.commit("setPivotGridOptions", {...this.pivotGridOptions, ...pivotItem});
      db.pivotTable.updateOptions(options, this.dataKey);
    },
    updateData() {
        const pivotData = this.pivotGridOptions[this.dataKey];
        this.dataOptions = pivotData ? JSON.parse(pivotData.options || '{}') : {};
        this.dataProvider = pivotData ? pivotData.dataProvider : '';
        this.dataName = pivotData ? pivotData.name : '';
    }
  },
  mounted () {
    this.updateData();
  },
  beforeDestroy () {
    this.dataProvider = null
    this.eventBus = null
  }
}
</script>
<style >
  .pvtAxisContainer {
    background: white;
    margin:unset;
    border: unset;
    width: 100%;
  }
  .pvtAxisContainer .dropdown-menu li {
    padding: 0;
  }
</style>
